<template>
  <section id="contact">
    <div class="hero-image">
      <img src="../../static/static-css/img/about-us/about.jpg" alt />
      <div class="overlay"></div>
    </div>
    <div class="dasboard-content">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="tittle">
              <h3>Our Customers</h3>
            </div>
            <div class="content">
              <p>
                Unfortunately none of the customers have chosen to share their names.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      // submitted: false,
      formError: '',
      apiresponse: '',
      contactForm: {
        full_name: '',
        email: '',
        message: '',
        reason: ''
      }
    }
  },
  methods: {
    checkForm: function () {
      this.formError = ''
      this.errors = ''
      if (!this.contactForm.full_name.trim()) {
        this.formError += 'Full Name required.<br>'
      }
      if (!this.contactForm.reason.trim()) {
        this.formError += 'Select reason.<br>'
      }
      if (!this.contactForm.message.trim()) {
        this.formError += 'Message should not be empty.<br>'
      }
      if (!this.contactForm.email.trim()) {
        this.formError += 'Email required.<br>'
      } else if (!this.validEmail(this.contactForm.email.trim())) {
        this.formError += 'Valid email required.<br>'
      }
      if (this.formError === '') return true
      else return false
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    },
    clearInputs: function () {
      this.contactForm.full_name = ''
      this.contactForm.reason = ''
      this.contactForm.message = ''
      this.contactForm.email = ''
    },
    async sendMail () {
      if (this.checkForm()) {
        let response = await this.$store.dispatch('SUBMIT_FORM', this.contactForm)
        // response = response.data
        // console.log(response.data.message)
        this.clearInputs()
        if (response.status === 200 || response.status === 201) {
          this.formError = ''
          this.$swal.fire(
            'Good job!',
            'We receive your message Thank You!',
            'success'
          )
        } else {
          this.formError = ''
          this.$swal.fire(
            'Error!',
            'Something Went Wrong',
            'warning'
          )
        }
      }
    }
  },
  created () {
    this.$store.commit('ISLOADING', false)
  }
}
</script>

<style>
.hero-image {
  position: relative;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0,0,0,0.5);
}

.hero-image img {
  max-height: 500px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/OurCustomers.vue